export enum IntegrationState {
    NotCreated = 0,
    Active = 1,
    Closed = 2,
    Error = 3
}